export enum TrialType {
  none = 'none',
  free = 'free',
  paid = 'paid',
}

export const DEFAULT_TRIAL_PERIOD_DAYS = 7
